export const ROUTES = {
    HOME: "",
    ABOUTUS: "a-propros-de-nous",
    CONTACT: "contact",
    LOGIN: "login",
    PRODUCTS_LIST: "products-list",
    PRODUCT_DETAIL: "product-detail",
    ORDERS_LIST: "order-list",
    CONFIRMATION_SUCCESSFUL:"thank-you",
    BASKET: "panier",
    PROFILE: "profile",
    dashboard: "yx6wrc8w322m744j-ecom-app",
    ADMIN_DASHBOARD: "yx6wrc8w322m744j-ecom-app/admin/dashboard",
    ADMIN_PRODUCTS: "yx6wrc8w322m744j-ecom-app/admin/products",
    ADMIN_ORDERS: "yx6wrc8w322m744j-ecom-app/admin/orders",
    ADMIN_CATEGORIES: "yx6wrc8w322m744j-ecom-app/admin/categories",
    ADMIN_POSTALCODES: "yx6wrc8w322m744j-ecom-app/admin/postalcodes",
    ADMIN_PUBS: "yx6wrc8w322m744j-ecom-app/admin/pubs",
    ADMIN_BANNERS: "yx6wrc8w322m744j-ecom-app/admin/banners",
    ADMIN_LOGIN: "yx6wrc8w322m744j-ecom-app/admin/login"
}